import { configureStore } from '@reduxjs/toolkit';
import loginReducer from '../components/Dentapp/Login/loginSlice';
import labReducer from '../components/Dentapp/Lab/labSlice';
import orderReducer from '../components/Dentapp/Lab/Orders/orderSlice';
import jobReducer from '../components/Dentapp/Job/jobSlice';

export const store = configureStore({
  reducer: {
    login: loginReducer,
    lab: labReducer,
    order: orderReducer,
    job: jobReducer,
  },
});